import Vue from 'vue'

const apis = {
  QUERY_LIST_BUSINESS_DATA: {
    url: '/xdap-app/business/query/dataSelectorData',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_ALL_BUSINESS_DATA: {
    url: '/xdap-app/business/query/allSelectorData',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_OTHER_FORM_FILED_LINE_DETAIL: {
    url: '/xdap-app/business/query/singleDataSelectorData',
    method: 'get',
    disableSuccessMsg: true
  }
}

const FormWidgetLovConfig = {
  // 类型
  componentType: 'FORM_DATA_SELECTOR',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-lov',
    text: '数据选择',
    optionTitle: true,
    description: '用于选择其他表单的数据字段'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormWidgetLov',
      edit: 'FormWidgetLov',
      read: 'FormWidgetLov'
    },
    label: '数据选择',
    placeholder: '请选择',
    dataSelector: {
      type: 'LOV_CHOOSE'
    },
    inTable: true,
    methods: {
      lcLoadRemoteData: (config, formData, globalData, formConfigList, type, pageInfo, isQueryAllData) => {
        let request = {
          ...apis.QUERY_LIST_BUSINESS_DATA
        }
        if (isQueryAllData) {
          request = {
            ...apis.QUERY_ALL_BUSINESS_DATA
          }
        }
        request.params = {
          ...pageInfo,
          formId: globalData.formId,
          componentId: config.uuid
        }
        return Vue.prototype.$request(request).then((resp) => {
          return {
            data: resp.data.map((item) => {
              return {
                value: item.id,
                label: item[config.dataSelector.otherComponent],
                extra: item
              }
            }),
            total: resp.total
          }
        })
      },
      lcGetOtherFormDetailByDocumentId(...args) {
        return new Promise((resolve, reject) => {
          const data = args[args.length - 1]
          const request = { ...apis.QUERY_OTHER_FORM_FILED_LINE_DETAIL }
          request.params = data
          Vue.prototype
            .$request(request)
            .asyncThen(
              (resp) => {
                resolve(resp)
              },
              (err) => {
                resolve(err)
              }
            )
            .asyncErrorCatch((err) => {
              reject(err)
            })
        })
      }
    }
  },
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'LOV_CHOOSETYPE',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormWidgetLovConfig
